// extracted by mini-css-extract-plugin
module.exports = {"partner-image":"PartnerCard_partner-image__1wWfL","partner-name":"PartnerCard_partner-name__1F8Ih","partner-description":"PartnerCard_partner-description__2f_UX"};